import { consumptionAPI } from "./clients";

//=================== Authentication routes ==========================
/**
 *  Endpoint to register a user
 * @param {String} name
 * @param {String} email : Email/identifier
 * @param {String} password
 * @param {String} role
 */
const register = (name, email, password, account_id) => {
  const endpoint = `/signup`;
  return consumptionAPI.post(endpoint, {
    name,
    email,
    password,
    account_id: account_id || "",
  });
};

/**
 * Signs in a user with email and password
 * @param {String} email
 * @param {String} password
 */
const signin = (email, password) => {
  const endpoint = `/login`;
  return consumptionAPI.post(endpoint, {
    email,
    password,
  });
};

/**
 * SignsIn/SignUps an user with google account token
 * @param {String} googleToken Google auth token
 * @param {String} account_id Account id of the organisation
 */
const googleSignIn = (googleToken, account_id) => {
  const endpoint = `/google-signup`;

  return consumptionAPI.post(endpoint, {
    google_token: googleToken,
    account_code: account_id || "",
  });
};

export { signin, register, googleSignIn };
